import { ContentfulProvider } from 'modules/content-cms/components/context';
import { GetServerSideProps, NextPage } from 'next';
import { getExistingCustomerFromCookies } from 'utils/cookies';
import { CollectionResponse, fetchCollectionProducts } from '../../api/product';
import {
  FetchContentRes,
  fetchContentfulByHandle,
  fetchContentfulShopifyData,
} from '../../connectors/contentful';
import { IProductPages } from '../../global';
import Cats from '../../modules/landingpage/cats';

const EC_COLLECTION_HANDLES = [
  { title: 'Snacks', collectionHandle: 'fur-katzen-snacks' },
  { title: 'Zubehör', collectionHandle: 'fur-katzen-zubehor' },
];

interface PropTypes {
  contentfulData: IProductPages;
  contentfulHandle: string;
  contentfulShopifyData: FetchContentRes;
  ecCollection: CollectionResponse;
  allCollections: Array<{
    title: string;
    collectionHandle: string;
  }>;
  isExistingCustomer: boolean;
}

const Katzen: NextPage<PropTypes> = ({
  ecCollection,
  contentfulData,
  contentfulHandle,
  contentfulShopifyData,
  isExistingCustomer,
}) => {
  return (
    <ContentfulProvider
      handle={contentfulHandle}
      shopifyData={contentfulShopifyData}
      fallbackData={contentfulData}
    >
      <Cats
        ecCollection={ecCollection}
        allCollections={EC_COLLECTION_HANDLES}
        isExistingCustomer={isExistingCustomer}
      />
    </ContentfulProvider>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const contentfulHandle = `pages/${process.env.CATS}`;

  const isExistingCustomer = getExistingCustomerFromCookies(context);

  try {
    const contentfulDataPromise = fetchContentfulByHandle(contentfulHandle);

    const ecCollectionPromise = fetchCollectionProducts(
      EC_COLLECTION_HANDLES[0].collectionHandle
    );

    const [contentfulData, ecCollection] = await Promise.all([
      contentfulDataPromise as Promise<IProductPages | null>,
      ecCollectionPromise,
    ]);

    if (contentfulData === null) {
      return { notFound: true, revalidate: 5 };
    }

    return {
      props: {
        contentfulData,
        contentfulHandle,
        contentfulShopifyData: await fetchContentfulShopifyData(contentfulData),
        ecCollection,
        isExistingCustomer,
      },
    };
  } catch (error) {
    console.error(`Error while prefetching data for page: ${contentfulHandle}`);
    return { notFound: true, revalidate: 5 };
  }
};

export default Katzen;
